module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-head"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_Foreword"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Maps"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maps")])])]), _vm._v(" "), _c('h2', {
    staticClass: "hang-toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("I")]), _vm._v(" Background")])]), _vm._v(" "), _c('h2', {
    staticClass: "hang-toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("II")]), _vm._v(" The Situation to 18 November 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "hang-toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("III")]), _vm._v(" The Situation in Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("1.")]), _vm._v("Terrain")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("2.")]), _vm._v("Weather")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("3.")]), _vm._v("Visibility")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("4.")]), _vm._v("Balance of Forces")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("5.")]), _vm._v("Weapons Comparison")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("6.")]), _vm._v("British Forces")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("7.")]), _vm._v("German–Italian Forces")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("8.")]), _vm._v("Positions")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("9.")]), _vm._v("Maps")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#sect-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("10.")]), _vm._v("Clock Times")])]), _vm._v(" "), _c('h2', {
    staticClass: "hang-toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("IV ")]), _vm._v("The Course of the Battle")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("A.")]), _vm._v("The British Eighth Army Launches the Attack")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("B.")]), _vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Afrika Korps")]), _vm._v(" Accepts Battle")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("C.")]), _vm._v("The Armoured Battle and Operational Movements")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }), _vm._v("The Decisive Engagement")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }), _vm._v("Subsidiary Fighting")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }), _vm._v("The High Point")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }), _vm._v("The German Drive Into the Strategic Depth")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("D.")]), _vm._v("The Crisis South-east of Tobruk ")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }), _vm._v("Attrition of the DAK at Capuzzo and Bardia")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }), _vm._v("The Situation on the Night of 26 November ")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }), _vm._v("The DAK Thrusts West")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("E.")]), _vm._v(" The Bel Hamed Pocket")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#sect-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("F.")]), _vm._v(" The Battle is Over; The Fight Continues")])]), _vm._v(" "), _c('h2', {
    staticClass: "hang-toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("V")]), _vm._v(" Conclusion")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Conclusion#sect-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("a)")]), _vm._v(" Historical Considerations")])]), _vm._v(" "), _c('h3', {
    staticClass: "hang-toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Conclusion#sect-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("b)")]), _vm._v(" Tactical Considerations")])]), _vm._v(" "), _c('h2', {
    staticClass: "hang-toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("VI")]), _vm._v(" Sources")])]), _vm._v(" "), _c('h2', {
    staticClass: "hang-toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("VII")]), _vm._v(" Annotations and Abbreviations")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0